import { collection, query, getDocs, getDoc, doc, where } from 'firebase/firestore';
import { db } from './../firebase';
import moment from 'moment';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

export const ExportPDF = async () => {
  // 1. Fecha del mes objetivo a exportar (por defecto, el mes anterior)
  const targetDate = moment().subtract(1, 'month');

  // 2. Obtiene todos los usuarios cuyo estado de sesión no esté deshabilitado
  const users = await getDocs(query(collection(db, 'users'), where('estadoSesion', '!=', 'Deshabilitado')));
  users.forEach((user) => {
    if (user.data().estadoSesion !== 'Deshabilitado') {
      // 3. Obtiene los registros del usuario para el mes y año objetivo
      getDoc(doc(db, 'users', user.id, 'registros', targetDate.format('MMMM-YYYY'))).then(async (document) => {
        let theoretical = 0; // Horas teóricas mensuales en minutos
        let absences = 0; // Filas de ausencias formateadas para la tabla
        let real = 0; // Horas reales mensuales acumuladas en minutos
        let calendar = {};

        // 4. Comprueba si el usuario tiene asignado un calendario laboral para el año objetivo
        if (user.data().calendario?.[targetDate.format('YYYY')]) {
          // Obtiene los datos del calendario para el mes objetivo
          calendar = await getDoc(doc(db, 'calendars', user.data().calendario[targetDate.format('YYYY')].id)).then((document) => {
            return document.data().data[targetDate.format('MMMM')];
          });

          // Calcula las horas teóricas del mes en minutos
          theoretical = calendar.total.split(':')[0] * 60 + parseInt(calendar.total.split(':')[1]);

          // 5. Obtiene las ausencias aceptadas del usuario dentro del mes objetivo
          absences = await getDocs(query(collection(db, 'users', user.id, 'ausencias'), where('status', '==', 'Aceptado'))).then((doc) => {
            const days = [];
            doc.forEach((document) => {
              if (
                moment(document.data().startDate, 'DD/MM/YYYY').format('MM/YYYY') === targetDate.format('MM/YYYY') ||
                moment(document.data().endDate, 'DD/MM/YYYY').format('MM/YYYY') === targetDate.format('MM/YYYY')
              ) {
                let start = moment(document.data().startDate, 'DD/MM/YYYY');
                let end = moment(document.data().endDate, 'DD/MM/YYYY');

                // Si la ausencia abarca más de un mes, ajusta los límites al mes actual
                if (start.format('MM') !== end.format('MM')) {
                  if (start.format('MM') === targetDate.format('MM')) {
                    end = moment(start).endOf('month');
                  } else {
                    start = moment(end).startOf('month');
                  }
                }

                // Si la ausencia es de un solo día
                if (start.format('YYYY/MM/DD') === end.format('YYYY/MM/DD')) {
                  days.push([
                    start.format('DD-MM-YYYY'),
                    '',
                    '',
                    '',
                    { content: calendar.days[start.format('D') - 1].hours.substr(1), styles: { fontStyle: 'bold' } },
                    document.data().type,
                  ]);
                  real = real + parseInt(calendar.days[start.format('D') - 1].hours.split(':')[0]) * 60 + parseInt(calendar.days[start.format('D') - 1].hours.split(':')[1]);
                } else {
                  // Si la ausencia abarca un rango de varios días
                  for (var m = start.clone(); m.isBefore(end.clone().add(1, 'days')); m.add(1, 'days')) {
                    days.push([
                      m.format('DD-MM-YYYY'),
                      '',
                      '',
                      '',
                      { content: calendar.days[m.format('D') - 1].hours.substr(1), styles: { fontStyle: 'bold' } },
                      document.data().type,
                    ]);
                    real = real + parseInt(calendar.days[m.format('D') - 1].hours.split(':')[0]) * 60 + parseInt(calendar.days[m.format('D') - 1].hours.split(':')[1]);
                  }
                }
              }
            });
            return days;
          });

          var data = [];

          // 6. Procesa los fichajes diarios si existen registros
          if (document.data()) {
            var datos = Object.entries(document.data()).sort();
            var long1 = Object.entries(document.data()).length;

            for (var i = 0; i < long1; i++) {
              var long2 = Object.keys(datos[i][1]).length;
              var totalPreviousRecord;

              // Recorre cada tramo de la jornada diaria
              for (var j = 0; j < long2; j++) {
                const unordered = datos[i][1][j];
                const ordered = {};
                Object.keys(unordered)
                  .sort()
                  .forEach(function (key) {
                    ordered[key] = unordered[key];
                  });

                // Extrae duración del tramo y total acumulado del día
                const totalTramo = unordered.total !== undefined ? unordered.total : Object.values(ordered)[2];
                const totalDia = unordered.totalAcumulado !== undefined ? unordered.totalAcumulado : Object.values(ordered)[3];

                // Observaciones: incluye la justificación si es festivo (tpFestivo)
                const obs = unordered.tpFestivo
                  ? `${unordered.tpRegistro || 'Festivo'} (${unordered.tpFestivo})`
                  : unordered.tpRegistro || unordered.tpIncidencia || (Object.values(ordered).length > 4 ? Object.values(ordered)[4] : '');

                if (totalDia) {
                  totalPreviousRecord = totalDia;
                }

                // 7. En el último tramo de la jornada: suma las horas al acumulado real si no está pendiente
                if (j === long2 - 1) {
                  if (datos[i][1][0]?.status !== 'Pendiente') {
                    if (totalDia) {
                      real = real + totalDia.split(':')[0] * 60 + parseInt(totalDia.split(':')[1]);
                    } else if (totalPreviousRecord) {
                      real = real + totalPreviousRecord.split(':')[0] * 60 + parseInt(totalPreviousRecord.split(':')[1]);
                    }
                  }
                  totalPreviousRecord = undefined;
                }

                // Prepara la fila de la tabla
                var arrReg = [];
                arrReg[0] = datos[i][0]; // Fecha
                arrReg[1] = Object.values(ordered)[0].indexOf('<i') !== -1 ? 'Viaje' : Object.values(ordered)[0]; // Entrada

                // Salida
                if (Object.values(ordered)[1].indexOf('<i') !== -1) {
                  arrReg[2] = 'Viaje';
                } else if (Object.values(ordered)[1].indexOf('<strong') !== -1) {
                  arrReg[2] = Object.values(ordered)[1].slice(8, 13) + ' (*)';
                } else {
                  arrReg[2] = Object.values(ordered)[1];
                }

                // Solo el último registro del día lleva el Total Día en negrita
                const isLastRecordOfDay = j === long2 - 1;

                arrReg[3] = totalTramo; // Duración del tramo
                arrReg[4] = isLastRecordOfDay ? { content: totalDia || '', styles: { fontStyle: 'bold' } } : totalDia || ''; // Total Día
                arrReg[5] = obs; // Observaciones / Motivo festivo

                data.push(arrReg);
              }
            }

            // 8. Combina fichajes con ausencias y ordena cronológicamente
            data = data.concat(absences);
            data.sort(function (a, b) {
              var dateA = a[0].split('-').reverse().join('');
              var dateB = b[0].split('-').reverse().join('');
              return dateA.localeCompare(dateB);
            });

            // 9. Agrega filas de totales al pie de la tabla
            data.push([
              ' ',
              ' ',
              ' ',
              ' ',
              { content: 'Teorico mes:', styles: { fontStyle: 'bold' } },
              { content: Math.floor(theoretical / 60) + ':' + (theoretical % 60 < 10 ? '0' : '') + (theoretical % 60), styles: { fontStyle: 'bold' } },
            ]);
            data.push([
              ' ',
              ' ',
              ' ',
              ' ',
              { content: 'Acumulado:', styles: { fontStyle: 'bold' } },
              { content: Math.floor(real / 60) + ':' + (real % 60 < 10 ? '0' : '') + (real % 60), styles: { fontStyle: 'bold' } },
            ]);
          }

          // 10. Creación y formateo del documento jsPDF
          var img = new Image();
          img.src = 'static/media/logo.png';
          var file = new jsPDF();
          file.setFont('Helvetica', 'normal', 'bold');
          file.text(20, 25, 'Control Horario CETEM');
          file.setFont('Helvetica', 'normal', '400');
          file.text('Usuario: ' + user.data().displayName, 20, 35);
          moment.locale('es');
          file.text('Mes: ' + targetDate.format('MMMM'), 20, 40);
          file.addImage(img, 'PNG', 120, 15);

          // Configuración y renderizado de la tabla con autoTable
          var columns = ['Fecha', 'Entrada', 'Salida', 'T. Tramo', 'Total Día', 'Observaciones'];
          file.autoTable(columns, data, {
            margin: { top: 45 },
            headStyles: { fillColor: [226, 149, 0], fontSize: 12 },
            columnStyles: { 4: { textColor: [0, 0, 0] } },
          });

          // 11. Descarga el archivo (marca con 'Error - ' si las horas reales no alcanzan las teóricas)
          if (real > theoretical) {
            file.save(user.data().displayName + '.pdf');
          } else {
            file.save('Error - ' + user.data().displayName + '.pdf');
          }
        } else {
          alert(user.data().displayName + ' no tiene calendario asignado para el año ' + targetDate.format('YYYY') + ' y no se puede generar el informe.');
        }
      });
    }
  });
};

export default ExportPDF;
